const KEYWORD_TAGS = [
  { pattern: /\b(methodic|precise|systematic|rigorous|structur)\w*/i, tag: 'methodical' },
  { pattern: /\b(curio|inquisit|explor|wander)\w*/i, tag: 'curious' },
  { pattern: /\b(warm|empathe|caring|gentle|kind)\w*/i, tag: 'warm' },
  { pattern: /\b(playful|whimsi|quirky|cheeky)\w*/i, tag: 'playful' },
  { pattern: /\b(analytic|logical|rational)\w*/i, tag: 'analytical' },
  { pattern: /\b(direct|blunt|candid|frank|plain[\s-]spoken)\w*/i, tag: 'direct' },
  { pattern: /\b(creat|invent|imagin|origin)\w*/i, tag: 'creative' },
  { pattern: /\b(patien|steady|calm|measured|grounded)\w*/i, tag: 'patient' },
  { pattern: /\b(bold|confiden|assertive|decisive)\w*/i, tag: 'bold' },
  { pattern: /\b(focus|disciplin|driven)\w*/i, tag: 'focused' },
  { pattern: /\b(skeptic|question|doubt)\w*/i, tag: 'skeptical' },
  { pattern: /\b(witt|humor|funny|clever)\w*/i, tag: 'witty' },
  { pattern: /\b(thorough|meticul|detail)\w*/i, tag: 'thorough' },
  { pattern: /\b(quick|sharp|brisk|snap)\w*/i, tag: 'quick' },
  { pattern: /\b(strateg|deliber)\w*/i, tag: 'strategic' },
  { pattern: /\b(perceptive|observ|astute|attentive)\w*/i, tag: 'perceptive' },
  { pattern: /\b(practical|pragmat|no-nonsense)\w*/i, tag: 'pragmatic' },
  { pattern: /\b(reflect|contemplative|thoughtful)\w*/i, tag: 'reflective' },
  { pattern: /\b(curt|terse|concise|brief)\w*/i, tag: 'concise' },
  { pattern: /\b(encourag|supportive|affirm)\w*/i, tag: 'encouraging' },
];

function scanKeywords(text, taken) {
  if (!text) return [];
  const found = [];
  for (const { pattern, tag } of KEYWORD_TAGS) {
    if (taken.has(tag)) continue;
    if (pattern.test(text)) {
      found.push(tag);
      taken.add(tag);
    }
  }
  return found;
}

export function deriveTags(characterConfig) {
  if (!characterConfig) return [];
  const taken = new Set();
  const result = [];

  // Strongest signal first: quirks then beliefs
  for (const tag of scanKeywords(characterConfig.quirks_and_mannerisms, taken)) {
    result.push(tag);
    if (result.length >= 5) return result;
  }
  for (const tag of scanKeywords(characterConfig.beliefs_and_intents, taken)) {
    result.push(tag);
    if (result.length >= 5) return result;
  }
  for (const tag of scanKeywords(characterConfig.personality_prompt, taken)) {
    result.push(tag);
    if (result.length >= 5) return result;
  }
  return result;
}

export function deriveTrait(characterConfig) {
  const tags = deriveTags(characterConfig);
  if (tags.length === 0) return 'Adaptive';
  const first = tags[0];
  return first.charAt(0).toUpperCase() + first.slice(1);
}
